'use es6';

import { CONVERSATION_TYPE_ID } from 'customer-data-objects/constants/ObjectTypeIds';
import ConversationPropertyReferenceResolver from 'reference-resolvers/resolvers/ConversationPropertyReferenceResolver';
import ObjectDefinitionRecord from '../ObjectDefinitionRecord';
const Conversation = ObjectDefinitionRecord({
  enableAsAssociatedType: true,
  objectTypeId: CONVERSATION_TYPE_ID,
  getPropertyResolver: () => ConversationPropertyReferenceResolver,
  referenceObjectType: 'CONVERSATION_PROPERTIES'
});
export default Conversation;